import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

function CareersSlide({ image }) {
  return (
    <section className="relative h-full min-h-[300px] md:min-h-400 aspect-2 ">
      {image?.gatsbyImageData && (
        <GatsbyImage
          className="h-full min-h-[300px] md:min-h-400 object-cover object-center"
          image={image.gatsbyImageData}
          alt={image.title}
        />
      )}
    </section>
  )
}
export default CareersSlide
